const BUTTON_THEMES = {
  PRIMARY: 'primary',
  TRANSPARENT: 'transparent',
  DELETE: 'delete',
  BORDERED: 'bordered',
}

export default BUTTON_THEMES
